import styled from '@emotion/styled';

const StyledForm = styled('form')({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
});

export default StyledForm;
